export default __webpack_public_path__ + "static/media/0x61299774020da444af134c82fa83e3810b309991.03a32840.webp";